import { getAccessToken, clearAuthData } from './authService';
import { apiClient } from './apiClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

const multipartFetch = async (url, formData, method = 'POST') => {
  const token = getAccessToken();
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_BASE_URL}${url}`, { method, body: formData, headers });
  if (!res.ok) {
    if (res.status === 401 || res.status === 403) {
      clearAuthData();
      window.location.href = '/admin/login';
      throw new Error('인증이 만료되었습니다. 다시 로그인해주세요.');
    }
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) {
      const j = await res.json();
      throw new Error(j.message || '요청 처리에 실패했습니다.');
    }
    throw new Error('서버에서 올바른 응답을 받지 못했습니다.');
  }
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : null;
};

export const getStorePhotos = async (storeId) =>
  apiClient(`/admin/management/stores/${storeId}/photos`, { method: 'GET' }, true);

export const uploadStorePhotos = async (storeId, files) => {
  const fd = new FormData();
  files.forEach((f) => fd.append('photos', f));
  return multipartFetch(`/admin/management/stores/${storeId}/photos`, fd, 'POST');
};

export const deleteStorePhoto = async (storeId, photoId) =>
  apiClient(`/admin/management/stores/${storeId}/photos/${photoId}`, { method: 'DELETE' }, true);

export const getSeatPhotos = async (storeId, seatId) =>
  apiClient(`/admin/management/stores/${storeId}/seats/${seatId}/photos`, { method: 'GET' }, true);

export const uploadSeatPhotos = async (storeId, seatId, files) => {
  const fd = new FormData();
  files.forEach((f) => fd.append('photos', f));
  return multipartFetch(`/admin/management/stores/${storeId}/seats/${seatId}/photos`, fd, 'POST');
};